<p-toast></p-toast>
<p-card>
    <!-- <div style="text-align: center;">
        <p-progressSpinner *ngIf="loading" [style]="{width: '200px', height: '200px'}"></p-progressSpinner>
    </div> -->

    <div class="p-fluid p-formgrid p-grid">
        <div class="p-col-12 p-md-6 p-lg-4">
            <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" *ngIf="loading"></p-progressBar>
            <p-table #dt [value]="lista" [rows]="25" [paginator]="true" [scrollable]="true" scrollHeight="680px"
                [globalFilterFields]="['apelido']" [(selection)]="selecionados" [rowHover]="true" dataKey="cod_funcionario"
                styleClass="p-datatable-customers">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value,'contains')"
                                placeholder="Pesquisar..." />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 10rem">Imagem
                        </th>
                        <th pSortableColumn="apelido">Nome
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-dados>
                    <tr style="cursor:pointer;" (click)="setarPosicao(gmap.getMap(), dados)">
                      
                        <td style="width: 10rem"><img [src]="dados.endereco_imagem" [alt]="dados.nome" width="100"
                                class="p-shadow-4" />
                        </td>
                        <td>
                            {{dados.apelido }}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        Registros: {{lista? lista.length: 0}}
                    </div>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="2" style="text-align: center;font-size: large;">Não há registros.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="p-col-12 p-md-6 p-lg-8">
            <div class="p-col-12 p-md-6 p-lg-12">
                <button style="height: 39.272px;" pButton pRipple type="button" label="Atualizar o Mapa" icon="pi pi-refresh"
                    class="p-button-raised" (click)="AtualizarMapa()">
                </button>
            </div>
            <br />
            <p-gmap #gmap [style]="{'width':'100%','height':'820px', 'margin-bottom': '1em'}" [options]="options"
                [overlays]="overlays" (onOverlayClick)="handleOverlayClick($event)"></p-gmap>
        </div>
    </div>

    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
</p-card>